<template>
	<div class="_dashboard-body">
		<div class="container-fluid bg-white mb-1">
			<div class="row g-0 py-2 py-xl-3 align-items-center">
				<div class="col-5 col-sm-auto">
					<!-- <img class="img-fluid" src="../assets/images/logo-04 (2).png" alt="no-img" width="150px" /> -->
				</div>
				<div class="col-7 col-sm-auto">
					<div class="fs-6 border-start border-2 border-red ms-2 ps-2">Administrator Portal</div>
				</div>

				<div class="border-bottom border-opacity-25 pt-2 mb-1 d-sm-none"></div>

				<div class="col-12 col-sm-auto ms-auto mt-1 mt-sm-0">
					<ul class="nav justify-content-between justify-content-sm-end">
						<li class="nav-item">
							<a class="nav-link dropdown-toggle link-dark text-secondary" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="fa-fw fa fa-user-circle"></i>
								Hallo
								<b class="text-red">{{ user_detail.ContactName ? user_detail.ContactName : UserDetail.ContactName }}</b>
							</a>
							<ul class="dropdown-menu dropdown-menu-end" style>
								<li>
									<router-link to="/my-account" class="dropdown-item" v-if="my_access ? my_access.find((o) => o.Group === 'My Account') : myAccess.find((o) => o.Group === 'My Account')">
										My Account
										<!-- <a class="dropdown-item"></a> -->
									</router-link>
								</li>
								<li>
									<router-link to="/documentation" class="dropdown-item">Documentations</router-link>
								</li>
								<li>
									<router-link to="/faqs" class="dropdown-item">FAQS</router-link>
								</li>
								<li>
									<hr class="dropdown-divider" />
								</li>
								<li>
									<a class="dropdown-item link-red pointer" @click="onLogout()">Sign Out</a>
								</li>
							</ul>
						</li>
						<li class="nav-item">
							<a class="nav-link dropdown-toggle link-dark text-red" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								<span class="badge rounded-pill bg-red" style="position: relative; left: 45px; top: -10px">{{ notif.length }}</span>
								<i class="fa-fw far fa-bell fa-lg"></i>
							</a>
							<ul class="dropdown-menu dropdown-menu-end p-2 border-0 shadow" style="width: 540px">
								<li v-for="(item, i) in notif" :key="i" :class="i % 2 == 0 ? 'border-red' : 'border-secondary'" class="rounded border-start border-3 bg-light mb-1 p-2 d-flex justify-content-between align-items-center">
									<a href="#" @click="notifRead(item.id)" class="link-secondary d-block text-decoration-none _alert-small me-2 pe-2 border-end border-1" title="Detail">
										<b>{{ item.Subject }}</b>
										<br />
										{{ item.Message }}
									</a>
									<div class="_alert-small text-secondary _nowrap text-center">
										{{ item.createdAt.replace('T', ' ').replace('.000Z', ' ').split(' ')[0] }}
										<br />
										{{ item.createdAt.replace('T', ' ').replace('.000Z', ' ').split(' ')[1] }}
									</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="container-fluid mb-4">
			<div class="row bg-white">
				<div class="col-12">
					<nav class="navbar navbar-expand-xl">
						<div class="container-fluid">
							<router-link to="/">
								<a class="navbar-brand fs-6 d-xl-none">Navigation</a>
							</router-link>
							<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
								<span class="navbar-toggler-icon"></span>
							</button>
							<div class="collapse navbar-collapse" id="navbarSupportedContent">
								<ul class="navbar-nav mx-auto mb-2 mb-lg-0">
									<li class="nav-item mx-2">
										<router-link to="/" class="nav-link" :class="menuActive == '/' ? 'active' : ''" aria-current="page"> <i class="fa-fw fa fa-tachometer-alt"></i> Dashboard </router-link>
									</li>
									<li class="nav-item mx-2">
										<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Request Managements') : myAccess.find((o) => o.Group === 'Request Managements')" to="/request-list" class="nav-link" :class="menuActive == 'request-list' ? 'active' : ''" aria-current="page"> <i class="fa-fw fa fa-th-large"></i> Request Managements </router-link>
									</li>
									<li class="nav-item mx-2">
										<router-link to="/monitoring-list" class="nav-link" :class="menuActive == 'monitoring-list' ? 'active' : ''" aria-current="page"><i class="fa-fw fa fa-desktop"></i> Monitoring </router-link>
									</li>
									<li class="nav-item mx-2">
										<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Ticket Support') : myAccess.find((o) => o.Group === 'Ticket Support')" to="/ticket-list" class="nav-link" :class="menuActive == 'ticket-list' ? 'active' : ''" aria-current="page"> <i class="fa-fw fa fa-ticket"></i> Ticket Supports </router-link>
									</li>
									<li class="nav-item mx-2 dropdown">
										<a v-if="my_access ? my_access.find((o) => o.Group === 'Billing Management') : myAccess.find((o) => o.Group === 'Billing Management')" class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true"> <i class="fa-fw fa fa-file-invoice"></i> Billing Managements </a>
										<ul class="dropdown-menu" data-bs-popper="static">
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.endpoint == '/invoices/list') : myAccess.find((o) => o.endpoint == '/invoices/list')" to="/invoice-list" class="dropdown-item" :class="menuActive == 'invoice-list' ? 'active' : ''">Invoices</router-link>
											</li>
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.endpoint == '/transaction/list') : myAccess.find((o) => o.endpoint == '/transaction/list')" to="/transaction-list" class="dropdown-item" :class="menuActive == 'transaction-list' ? 'active' : ''">Transactions</router-link>
											</li>
										</ul>
									</li>
									<li class="nav-item mx-2 dropdown">
										<a v-if="my_access ? my_access.find((o) => o.Group === 'Location Management') : myAccess.find((o) => o.Group === 'Location Management')" class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true"> <i class="fa-fw fa fa-map-marked-alt"></i> Location Area Managements </a>
										<ul class="dropdown-menu" data-bs-popper="static">
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.endpoint == '/location/area/branch') : myAccess.find((o) => o.endpoint == '/location/area/branch')" to="/dc-location" class="dropdown-item" :class="menuActive == 'dc-location' ? 'active' : ''"> Data Center Locations </router-link>
											</li>
											<!-- <li>
                        <hr class="dropdown-divider">
                      </li>-->
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.endpoint == '/location/area/building') : myAccess.find((o) => o.endpoint == '/location/area/building')" to="/buildings" class="dropdown-item" :class="menuActive == 'buildings' ? 'active' : ''">Buildings</router-link>
											</li>
											<!-- <li>
                        <router-link to="/floors" class="dropdown-item">Floors</router-link>
                      </li>
                      <li>
                        <router-link to="/rooms" class="dropdown-item">Rooms</router-link>
                      </li>-->
											<!-- <li><a class="dropdown-item" href="location-place_list.php">Places</a></li> -->
										</ul>
									</li>
									<li class="nav-item mx-2 dropdown" v-if="(my_access ? my_access.find((o) => o.Group === 'Company Management') : myAccess.find((o) => o.Group === 'Company Management')) || (my_access ? my_access.find((o) => o.Group === 'User Customer Management') : myAccess.find((o) => o.Group === 'User Customer Management'))">
										<a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <i class="fa-fw fa fa-user-cog"></i> Administrations </a>
										<ul class="dropdown-menu">
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Company Management') : myAccess.find((o) => o.Group === 'Company Management')" to="/company-management" class="dropdown-item" :class="menuActive == 'company-management' ? 'active' : ''">Company Managements</router-link>
											</li>
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'User Customer Management') : myAccess.find((o) => o.Group === 'User Customer Management')" to="/customer-management" class="dropdown-item" :class="menuActive == 'customer-management' ? 'active' : ''">PIC Managements</router-link>
											</li>
											<!-- <li>
                        <a class="dropdown-item" href="administration-report.php">
                          Reports &
                          Statistics
                        </a>
                      </li>
                      <li>
                        <hr class="dropdown-divider">
                      </li>
                      <li>
                        <a class="dropdown-item" href="administration-announcement_list.php">
                          Announcement
                          Managements
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="administration-docsfaqs_list.php">
                          Docs &
                          FAQS Managements
                        </a>
                      </li>-->
											<router-link to="/doc-faq-list" class="dropdown-item" :class="menuActive == 'doc-faq' ? 'active' : ''">Docs & FAQS Managements</router-link>
										</ul>
									</li>
									<li
										class="nav-item mx-2 dropdown"
										v-if="
											(my_access ? my_access.find((o) => o.Group === 'Product Management') : myAccess.find((o) => o.Group === 'Product Management')) ||
											(my_access ? my_access.find((o) => o.Group === 'Email Management') : myAccess.find((o) => o.Group === 'Email Management')) ||
											(my_access ? my_access.find((o) => o.Group === 'Rack Management') : myAccess.find((o) => o.Group === 'Rack Management')) ||
											(my_access ? my_access.find((o) => o.Group === 'User Admin Management') : myAccess.find((o) => o.Group === 'User Admin Management'))
										"
									>
										<a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <i class="fa-fw fa fa-cogs"></i> General Settings </a>
										<ul class="dropdown-menu">
											<!-- <li><a class="dropdown-item" href="setting-general.php">Generals</a></li> -->
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Product Management') : myAccess.find((o) => o.Group === 'Product Management')" to="/setting-product-list" class="dropdown-item" :class="menuActive == 'setting-product-list' ? 'active' : ''">Products & Services</router-link>
											</li>
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Email Management') : myAccess.find((o) => o.Group === 'Email Management')" to="/setting-email-template" class="dropdown-item" :class="menuActive == 'setting-email-template' ? 'active' : ''">Email Templates</router-link>
											</li>
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'Rack Management') : myAccess.find((o) => o.Group === 'Rack Management')" to="/setting-rack-list" class="dropdown-item" :class="menuActive == 'setting-rack-list' ? 'active' : ''">Rack Managements</router-link>
											</li>
											<li>
												<router-link v-if="my_access ? my_access.find((o) => o.Group === 'User Admin Management') : myAccess.find((o) => o.Group === 'User Admin Management')" to="/user-management" class="dropdown-item" :class="menuActive == 'user-management' ? 'active' : ''">User Managements</router-link>
											</li>
											<li>
												<hr class="dropdown-divider" />
											</li>
											<!-- v-if="my_access? my_access.find(o => o.Group === 'User Admin Management') : myAccess.find(o => o.Group === 'User Admin Management')" -->
											<router-link to="/log-user" class="dropdown-item" :class="menuActive == 'log-user' ? 'active' : ''">Log Activities</router-link>
										</ul>
									</li>
									<!-- <li class="nav-item mx-2"><a class="nav-link" aria-current="page" href="apendix.php">[Apendix]</a>
                  </li>-->
								</ul>
							</div>
						</div>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import TopNavbar from '../components/Navbar.vue'
import { mapGetters } from 'vuex'
export default {
	// components: {
	// 	'top-navbar': TopNavbar
	// }
	data() {
		return {
			// user_detaila: localStorage.getItem("user_detail"),
			user_detail: localStorage.getItem('user_detail') ? JSON.parse(localStorage.getItem('user_detail')) : [],
			notif: localStorage.getItem('notif') ? JSON.parse(localStorage.getItem('notif')) : [],
			my_access: localStorage.getItem('my_access') ? JSON.parse(localStorage.getItem('my_access')) : []
		}
	},
	mounted() {
		// let a = this.my_access.find(o => o.Group === "User Management");
		// console.log("====", this.my_access);
		// console.log("-----", a);
	},
	computed: {
		...mapGetters({
			UserDetail: 'auth/getUser_detail',
			myAccess: 'auth/getMyAccess',
			menuActive: 'settings/getMenuActive'
		})
	},
	methods: {
		onLogout: function () {
			this.$store
				.dispatch('auth/logout')
				.then((res) => {
					this.$router.push('/login')
				})
				.catch((err) => {})
		},
		notifRead(id) {
			this.$store
				.dispatch('auth/notifRead', {
					data: {
						notifid: id
					}
				})
				.then((res) => {
					let toast = this.$toasted.show(`${res.respond.response}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
				.catch((err) => {})
		}
	}
}
</script>
<style scoped></style>
<style lang="scss">
.bg-nav:hover {
	background: #f4f6f8;

	&.text-nav {
		color: #086ce8;
	}
}

// .navbar-light .navbar-nav .show > .nav-link,
// .navbar-light .navbar-nav .active > .nav-link,
// .navbar-light .navbar-nav .nav-link.show,
// .navbar-light .navbar-nav .nav-link.active {
// 	color: rgba(0, 0, 0, 0.9);
// 	border-bottom: 1px solid #9f121c;
// 	border-left: 1px solid #dbdee2;
// 	border-right: 1px solid #dbdee2;
// 	border-top: 1px solid #dbdee2;
// }

// .dropdown-item {
//   white-space: normal !important;
// }
</style>
